import { render, staticRenderFns } from "./PackWap.vue?vue&type=template&id=ee5e29d6&scoped=true&"
import script from "./PackWap.vue?vue&type=script&lang=js&"
export * from "./PackWap.vue?vue&type=script&lang=js&"
import style0 from "./PackWap.vue?vue&type=style&index=0&id=ee5e29d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5e29d6",
  null
  
)

export default component.exports